<template>
    <div>
        <img src="~@/assets/icons/empty.svg" class="m-auto" style="width: 50%; height: 50%;">
        <img src="~@/assets/icons/empty.svg" v-if="type === 'other'" class="m-auto" style="width: 50%; height: 50%;">
        <p class="text-center m-5 bold">
           {{message}}
        </p>
        <div class="flex justify-center ">
            <lms-button  v-if="redirect" class="btn-color  " textColor="#fff" @click="$router.push({name: route})"
            >{{redirect}}</lms-button
            >
        </div>
    </div>
</template>

<script>
    export default {
        name: "Empty",
        props: ["message","redirect","route","type"],
        components:{
            LmsButton: () => import("@/components/general/button"),
        }
    }
</script>

<style scoped>

</style>